<template>
  <div class="hello">

    <h1 class="title">Affordable Molecular Imaging for Global Health (AMIGH)</h1>
    <h2 class="description">
      Our mission: Stimulate international collaborations to implement frugal innovation approach to 
      medical imaging relevant to low- and middle-income countries to advance global health</h2>
    <div id="map"></div>

    <el-container :direction="'vertical'" style="padding: 20px;margin: 20px;  ">

      <el-header>
        <h2>Task Force for Affordable Molecular Imaging for Global Health (AMIGH)</h2>
      </el-header>
      <el-main>
        <el-table :data="OrganizationData" border fit highlight-current-row
          style="width: 80%; font-size: 16px; margin-left: 6%;">
          <el-table-column prop="name" label="Name" width="auto"></el-table-column>
          <el-table-column prop="Organization" label="Organization" width="auto"></el-table-column>

          <el-table-column prop="location" label="Location" width="auto"></el-table-column>
        </el-table>
      </el-main>
      <el-footer v-if="false" style="display: flex; align-items: center; justify-content: center;">
        <h4 style="margin-right: 20px;">The total number of visitors to this page is:</h4>
        <iframe title="Click me for more details"
          style="width: auto; height: 40px; border: none; display: flex; justify-content: center; margin-top: 5px; align-items: center; font-size: small;"
          ref="hiddenIframe" @mouseover="title = 'Click me for more details'"></iframe>
      </el-footer>


    </el-container>

    <el-drawer append-to-body title="详细信息" :visible.sync="showdetaildialog" :direction="'btt'" :show-close=false
      :modal=false :withHeader=false>
      <el-container style="padding: 20px;  ">
        <div v-for="item in currentInfo">
          <MyCard :heading="item.Organization" :description="item.name" :logoscr="item.logoscr" :link="item.website">
          </MyCard>
        </div>

      </el-container>

    </el-drawer>
    <div style="background-color: lightblue; padding: 20px; box-sizing: border-box;">
      <h3 style="text-align: left; color: #333; margin-bottom: 20px; margin-left: 30px;">Useful Links</h3>
      <div style="padding: 20px; background-color: #fff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
        <ul
          style="list-style: none; display: flex; flex-wrap: wrap; justify-content: center; align-items: center; padding: 0;">
          <li v-for="link in friendLinks" :key="link.name"
            style="margin: 10px; border-right: 1px solid #eee; padding-right: 10px;">
            <a :href="link.url" target="_blank"
              style="display: flex; flex-direction: column; align-items: center; text-decoration: none; color: #333;">
              <img :src="link.logo" alt="logo" style="width: 80px; height: 80px; margin-bottom: 5px;">
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>
<script>
// 如需扩张更多省市,在此处引入对应的地图JSON数据
// 
import world from '../../static/mapData/world.json'
import Mallki from '@/components/TextHoverEffect/Mallki'
import MyCard from './SmallCard/MyCard.vue';
import { worldData } from '@/assets/data/worldData.js'
import { organizationData } from '@/assets/data/organizationData.js'
import { name } from 'file-loader';
export default {
  name: "HelloWorld",
  components: {
    Mallki,
    MyCard
  },
  data() {
    return {
      showdetaildialog: false,
      showselect: false,
      value: "world",
      currentInfo: [],
      myChart: null,
      //   注册地图json
      jsonMap: {
        'world': world,
      },
      // 全球数据
      worldData: worldData,
      // 组织数据
      OrganizationData: organizationData,
      htmlcontent: [],
      // 地域名称映射（保持英文，不再把 China 映射为中文）
      nameMap: {},
      mapData: [
        { name: "world", value: 10 },
      ],
      logoCache: {},
      friendLinks: [
        {
          name: 'STRENGTHENING MEDICAL IMAGING CAPACITY',
          url: 'https://imagingcommission.org ',
          logo: require("@/assets/lancet-oncology.svg"),
        },
        {
          name: 'AMIL',
          url: 'https://pengqy-lab-cn.szbl.ac.cn/',
          logo: require("@/assets/szbl_1.svg"),
        },
        {
          name: 'LANCET',
          url: 'https://www.thelancet.com',
          logo: require("@/assets/LANCET-1665147351037.svg"),
        },
        {
          name: 'RSNA',
          url: 'https://www.rsna.org/',
          logo: require("@/assets/rsna.svg"),
        },
        {
          name: 'PETVISION',
          url: 'https://petvision.org/',
          logo: require("@/assets/PetVision-LogoBlue-banner.svg"),
        }
      ]
    };
  },
  created() {
    //   循环注册地图
    for (let index in this.jsonMap) {
      this.$echarts.registerMap(index, this.jsonMap[index])
    };

  },
  mounted() {
    // 初始化地图
    this.chinaConfigure(this.value);
    // this.flattenedData()

    this.$nextTick(() => {
      const iframe = this.$refs.hiddenIframe; // 通过 ref 获取 iframe
      if (!iframe) {
        // 创建一个新的 script 元素
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = "https://zz.ict58.com/cf.asp?username=penglab&asyncid=643067"; // 更新为新的 src
        script.id = "643067"; // 更新为新的 id
        // 将 script 标签添加到 iframe 的内容文档中
        try {
          iframe.contentWindow.document.body.appendChild(script);
        } catch (error) {
          console.warn('the counter script is not loaded');
        }
      }
    });
  },
  //   更新数据
  watch: {
    value(newVal) {
      this.myChart.dispose();
      this.chinaConfigure(this.value);
    }
  },
  beforeDestroy() {
    if (this._docClickHandler) {
      document.removeEventListener('click', this._docClickHandler);
      this._docClickHandler = null;
    }
    this._zrClickHandler = null;
    this._tipPoint = null;
    if (!this.myChart) {
      return;
    }
    this.myChart.dispose();
    this.myChart = null;
  },
  methods: {

    flattenedData() {
      let addedOrganizations = {};
      this.worldData.forEach(country => {
        country.organizations.forEach(org => {
          // 使用组织名称作为唯一标识符，也可以根据需要选择其他唯一属性
          if (!addedOrganizations[org.name]) {
            this.OrganizationData.push({
              index: this.OrganizationData.length + 1,
              countryName: country.name,
              organizationLocation: org.location,
              organizationName: org.name,
              organization: org.Organization,
              website: org.website,
            });
            // 标记该组织已添加
            addedOrganizations[org.name] = true;
          }
        });
      });

    },
    openWebsite(url) {
      window.open(url, '_blank');
    },
    chinaConfigure(area) {
      const vm = this; // 保存Vue实例的引用
      this.myChart = this.$echarts.init(document.getElementById("map"));
      window.onresize = this.myChart.resize;
      let option = {
        backgroundColor: "#FFFFFF",
        tooltip: {
          trigger: 'item',
          triggerOn: 'none', // 关闭 hover 触发，改由点击后手动控制
          backgroundColor: 'rgba(50,50,50,0.8)',
          textStyle: {
            color: '#FFFFFF' // 设置字体颜色为黑色
          },
          position: function (point, params, dom, rect, size) {
            // 让提示框居中出现在鼠标下方，并做边界钳制，保证完整可见
            // 优先使用点击时记录的坐标，保证提示框出现在点击处下方
            const anchor = (vm._tipPoint && vm._tipPoint.length === 2) ? vm._tipPoint : point;
            const contentW = size.contentSize[0];
            const contentH = size.contentSize[1];
            const viewW = size.viewSize[0];
            const viewH = size.viewSize[1];
            const gap = 15;
            let x = anchor[0] - contentW / 2;
            x = Math.max(5, Math.min(x, viewW - contentW - 5));
            let y = anchor[1] + gap;
            if (y + contentH > viewH - 5) {
              y = anchor[1] - contentH - gap;
            }
            y = Math.max(5, Math.min(y, Math.max(5, viewH - contentH - 5)));
            return [x, y];
          },
          formatter: (params) => { // 使用箭头函数确保this指向Vue实例
            if (params.value >= 0 && params.value <= 10) {
              // 按机构归组：key = 小写并折叠逗号/空白，保持首次出现顺序
              const order = [];
              const groups = {};
              (params.data.organizations || []).forEach(org => {
                const key = (org.Organization || '').toLowerCase().replace(/[,\s]+/g, ' ').trim();
                if (!groups[key]) {
                  groups[key] = { organization: org.Organization, names: [], logoscr: '', logoMaxWidth: '' };
                  order.push(key);
                }
                const g = groups[key];
                if (org.name) g.names.push(org.name);
                if (!g.logoscr && org.logoscr) g.logoscr = org.logoscr;
                if (!g.logoMaxWidth && org.logoMaxWidth) g.logoMaxWidth = org.logoMaxWidth;
              });

              // 固定卡片尺寸，让每个机构卡片长宽尽量一致
              const CARD_WIDTH = 300;      // 固定卡片宽度
              const CARD_HEIGHT = 200;     // 固定卡片高度
              const LOGO_SIZE = 80;        // 所有 logo 统一的固定方形盒子边长（宽=高）
              const CARD_BG = 'rgba(128, 128, 128, 0.5)';

              const organizationsHtml = order.map(key => {
                const g = groups[key];
                const namesHtml = g.names
                  .map(n => `<p style="margin:0; line-height:1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${n}</p>`)
                  .join('');
                const logoHtml = g.logoscr
                  ? `<img src="${g.logoscr}" style="width: ${LOGO_SIZE}px; height: ${LOGO_SIZE}px; object-fit: contain; display: block; margin-top: auto; align-self: center;" />`
                  : '';
                return `
        <div style="box-sizing: border-box; flex: 0 0 auto; white-space: nowrap; width: ${CARD_WIDTH}px; height: ${CARD_HEIGHT}px; display: flex; flex-direction: column; background-color: ${CARD_BG}; padding: 10px; overflow: hidden;">
          ${namesHtml}
          <p style="margin:6px 0 0 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${g.organization}</p>
          ${logoHtml}
        </div>`;
              }).join('');

              this.htmlcontent = `
      <div style="display: flex; flex-wrap: wrap; gap: 10px; width: max-content; max-width: 920px; white-space: normal; justify-content: center;">
        ${organizationsHtml}
      </div>
    `;

              return this.htmlcontent;
            } else {
              return ``;
            }
          },

        },
        visualMap: {
          show: false,
          max: 10,
          calculable: false,
          inRange: {
            color: ['#0868AC',]
          }
        },
        series: [{
          type: 'map',
          map: 'world', // 直接指定使用世界地图
          data: this.worldData, // 只使用世界地图的数据
          nameMap: this.nameMap // 使用世界地图的名称映射
        }]
      }
      this.myChart.setOption(option, true);

      // 点击地区：仅当该地区有机构数据时固定展示 tooltip
      this.myChart.off('click');
      this.myChart.on('click', params => {
        const organizations = params.data && params.data.organizations;
        if (organizations) {
          this.currentInfo = organizations;
        }
        if (organizations && organizations.length > 0) {
          // 记录点击坐标供 position() 使用：showTip 带 seriesIndex 时会忽略 x/y，故改用锚点变量
          const evt = params.event || {};
          if (typeof evt.offsetX === 'number' && typeof evt.offsetY === 'number') {
            this._tipPoint = [evt.offsetX, evt.offsetY];
          }
          this.myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: 0,
            dataIndex: params.dataIndex
          });
        } else {
          this.myChart.dispatchAction({ type: 'hideTip' });
        }
      });

      // 点击地图画布空白处：隐藏（按具名引用移除，避免误删 ECharts 内部事件转发器）
      if (this._zrClickHandler) {
        this.myChart.getZr().off('click', this._zrClickHandler);
      }
      this._zrClickHandler = e => {
        if (!e.target) {
          this.myChart.dispatchAction({ type: 'hideTip' });
        }
      };
      this.myChart.getZr().on('click', this._zrClickHandler);

      // 点击图表容器外部：隐藏（实例字段去重，避免重复初始化时监听累积）
      if (this._docClickHandler) {
        document.removeEventListener('click', this._docClickHandler);
      }
      this._docClickHandler = e => {
        const chartDom = document.getElementById('map');
        if (chartDom && !chartDom.contains(e.target) && this.myChart) {
          this.myChart.dispatchAction({ type: 'hideTip' });
        }
      };
      document.addEventListener('click', this._docClickHandler);
    },
    async getLogoUrl(organizationName) {
      if (this.logoCache[organizationName]) {
        return this.logoCache[organizationName];
      } else {
        // 模拟从服务器获取数据的过程

        for (const country of this.worldData) {
          for (const org of country.organizations) {
            if (org.Organization === organizationName) {
              // 找到匹配的组织，更新缓存并返回logoscr
              this.logoCache[organizationName] = org.logoscr || "默认logo_url";
              return this.logoCache[organizationName];
            }
          }
        }

        // 如果没有找到组织或logo URL，则返回一个默认的logo URL
        return "默认logo_url";
      }
    },
    preloadlogos() {
      for (const country of this.worldData) {
        for (const org of country.organizations) {
          this.getLogoUrl(org.Organization);
        }
      }
    },
    indexMethod(index) {
      return index + 1

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  font-size: 44px;
  /* 根据需要调整字体大小 */
  font-weight: bold;
  text-align: center;
  /* 如果需要居中显示 */
  margin: 20px 0;
  /* 添加一些上下边距 */
  white-space: nowrap;
  /* 防止跨行 */
  overflow: hidden;
  /* 防止内容溢出 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
}

.description {
  position: relative;
  z-index: 1000;
  top: 20px;
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  margin: 20px 0 0px 60px;
  /* 上 右 下 左 */
  text-overflow: ellipsis;
  color: purple;
  /* 字体颜色设置为紫色 */
}

.hello {

  position: relative;
  width: 100%;
  height: 100%;
}

.el-select {
  position: absolute;
  left: 20px;
  top: 20px;
}

#map {
  position: relative;
  width: 100%;
  height: 80%;
}

.organization-container {
  margin-bottom: 20px;
  break-inside: avoid;
  background-color: rgba(192, 192, 192, 0.5);
  padding: 10px;
  border-radius: 5px;
}

.organization-container:hover {
  background-color: rgba(192, 192, 192, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue